import { useMutation } from '@tanstack/react-query';

import { tvpil } from '../compat/tvpil';

import { addFavoriteChannel, deleteFavoriteChannel } from './mutations';
import { requestAddFavoriteChannel } from './queryFunctions';

type MutationFunctionProps = { channelId: number };

export function useAddFavoriteChannel() {
  const mutation = useMutation({
    mutationFn: ({ channelId }: MutationFunctionProps) => requestAddFavoriteChannel(channelId),
    onMutate: ({ channelId }) => {
      addFavoriteChannel(channelId);
      tvpil.syncFavoriteRepository();

      return channelId;
    },
    onError: (error, { channelId }) => {
      deleteFavoriteChannel(channelId);
      tvpil.syncFavoriteRepository();
    },
  });

  return {
    add: mutation.mutateAsync,
  };
}
